import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConnectionAlertService {
  private readonly visibleSubject = new BehaviorSubject<boolean>(false);
  readonly visible$: Observable<boolean> = this.visibleSubject.asObservable();

  show(): void {
    this.visibleSubject.next(true);
  }

  dismiss(): void {
    this.visibleSubject.next(false);
  }
}
